// extracted by mini-css-extract-plugin
module.exports = {"img":"__404_img___AFEr","btn":"__404_btn__02wgu","body":"__404_body__v3SuN","p":"__404_p__OMr3G","btnText":"__404_btnText__HZQoZ"};